<div class="modal-header flex flex-row justify-between items-center">
  <h1>Edit Field</h1>

  <mat-dialog-actions>
    <button class="material-icons" mat-dialog-close (click)="cancelClicked()"><i class="fa-regular fa-xmark"></i></button>
  </mat-dialog-actions>

</div>
<mat-dialog-content class="flex flex-row">
  <ng-template particleCellContainerHost> </ng-template>
</mat-dialog-content>
<mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
  <button mat-button class="mat-flat-button orbitax-footer-button"  mat-dialog-close (click)="cancelClicked()">Cancel</button>
  <button [disabled]="!isValid" mat-flat-button class="orbitax-footer-action-button mat-button mat-flat-button" type="button" (click)="okClicked()">
    Done
  </button>
</mat-dialog-actions>
